import { ColorGray100, ColorGray500, SpaceMd, SpaceXs } from "@nxt-costco-com/forge-design-tokens";
const getAccordionSx = (defaultDividerColor, hoverDividerColor, activeDividerColor) => ({
  "&.MuiAccordion-root": {
    "&:hover": {
      borderTopColor: `${hoverDividerColor} !important`,
      borderBottomColor: `${hoverDividerColor} !important`
    },
    "&::before": {
      backgroundColor: ColorGray500
    },
    ".MuiCollapse-root": {
      transitionDuration: "01ms !important"
    },
    overflow: "hidden",
    borderOpacity: 0.5,
    borderTopColor: `${defaultDividerColor} !important`,
    borderBottomColor: `${defaultDividerColor} !important`
  },
  "&.MuiAccordion-root.Mui-expanded": {
    "&::before": {
      opacity: 100
    },
    borderTopColor: `${activeDividerColor} !important`,
    borderBottomColor: `${activeDividerColor} !important`
  },
  backgroundColor: ColorGray100,
  boxShadow: "none",
  margin: 0
});
const getAccordionSummarySx = (backgroundColor) => ({
  "&.MuiButtonBase-root": {
    "&.MuiAccordionSummary-root": {
      padding: `${SpaceMd}`
    },
    "&:hover": {
      background: `${backgroundColor} !important`
    },
    background: `${backgroundColor} !important`,
    transitionDuration: "0ms"
  }
});
const accordionDetailsSx = {
  padding: `${SpaceXs} ${SpaceMd} ${SpaceMd} ${SpaceMd}`
};
export {
  accordionDetailsSx,
  getAccordionSummarySx,
  getAccordionSx
};
